import http from "./http";

class CommandesService {

    index(created_by, token) {
        return http.get(`/api/commandes/${created_by}`,{ headers: { 'Authorization': 'Bearer '+token } });
      }
      

    getUserCommandes(commande, token) {
        return http.get(`/api/commandes/paiement/${commande}`,{ headers: { 'Authorization': 'Bearer '+token } });
        }
      

    store(data,token){
        return http.post("/api/commandes/store", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    edit(id){
        return http.get(`/api/commandes/${id}/edit`)
    }

    show(id){
        return http.get(`/api/commandes/${id}/show`)
    }

    update(id, data){
        return http.post(`/api/commandes/${id}/update`, data)
    }

    delete(id){
        return http.delete(`/api/commandes/${id}/delete`)
    }

    paiement(code_transaction,data,token){
        return http.post(`/api/commande/paiement_store/${code_transaction}`, data,{ headers: { 'Authorization': 'Bearer '+token } })
    }

    /*checkTransactionStatut(data,token){
        return http.post("/api/paiement/kkiapay/checkstatut", data,{ headers: { 'Authorization': 'Bearer '+token } })
    }*/

    index_paiement(token) {
        return http.get("/api/liste_paiements",{ headers: { 'Authorization': 'Bearer '+token } });
      }

      detailscommandes(token, id) {
        return http.get(`/api/detailscommandes/${id}`,{ headers: { 'Authorization': 'Bearer '+token } });
      }
      
   
}

export default new CommandesService()